import { roundUpPrice } from '@/utils/circuits/prices/formatPrice';
import { parseMarginRateNumber } from '@/utils/common/parseMarginRateInput';

export type InternationalFlightsPricingInput = {
  nonMarginedTaxes?: number | string | null;
  htAmount?: number | string | null;
  isMargined?: boolean | string | null;
  flightsMarginRate?: number | string | null;
};

const toPricingNumber = (value: number | string | null | undefined): number => {
  if (typeof value === 'number' && Number.isFinite(value)) return value;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

const toMarginRateNumber = (
  value: number | string | null | undefined,
): number => parseMarginRateNumber(value) ?? 0;

const isMarginedFlightsRate = (
  value: boolean | string | null | undefined,
): boolean => value === true || value === 'true';

export const computeInternationalFlightsMarginAmount = ({
  htAmount,
  isMargined,
  flightsMarginRate,
}: InternationalFlightsPricingInput): number => {
  const ht = toPricingNumber(htAmount);
  if (!isMarginedFlightsRate(isMargined) || ht <= 0) return 0;
  return roundUpPrice(ht * (toMarginRateNumber(flightsMarginRate) / 100));
};

export const computeInternationalFlightsTotal = (
  input: InternationalFlightsPricingInput,
): number => {
  const taxes = toPricingNumber(input.nonMarginedTaxes);
  const ht = toPricingNumber(input.htAmount);
  const margin = computeInternationalFlightsMarginAmount(input);
  return roundUpPrice(taxes + ht + margin);
};
